import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedMethodsSection } from './components/FailedMethodsSection';
import { MethodSection } from './components/MethodSection';
import { BundleContents } from './components/BundleContents';
import { BonusSection } from './components/BonusSection';
import { ValueTable } from './components/ValueTable';
import { AudienceSection } from './components/AudienceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <SocialProofToast data-id="element-1" />
      <HeroSection data-id="element-2" />
      <OpeningHook data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <FailedMethodsSection data-id="element-5" />
      <MethodSection data-id="element-6" />
      <BundleContents data-id="element-7" />
      <BonusSection data-id="element-8" />
      <ValueTable data-id="element-9" />
      <AudienceSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <OfferSection data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}